import React, { useEffect, useState, useCallback } from "react";
import FormSelect from "../../hook-controls/select";
import { GetVerticaConfig } from "../../../module/master/api";

function ComoVerticaConfig({ module, ...props }) {
  const [Data, setData] = useState([]);

  const GetListcbx = useCallback(async () => {
    let data = await GetVerticaConfig({ module: module });
    const cbo =
      data &&
      data.map(({ HOST_TITLE: label, HOST_KEY: id }) => ({
        label,
        id,
      }));
    setData(cbo);
  }, [setData, module]);

  useEffect(() => {
    GetListcbx();
  }, [GetListcbx]);

  return (
    <>
      <FormSelect {...props} options={Data} />
    </>
  );
}

export default ComoVerticaConfig;
